import { render } from "./PageTitle.vue?vue&type=template&id=4b1cacc0&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=4b1cacc0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4b1cacc0"

export default script